import React, { useEffect, useState } from "react";
import "./style.css";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import { NavLink } from "react-router-dom";
import { Drawer, List, ListItem, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  handlePopup,
  handleSidebar,
  saveEnquiryData,
  resetEnquiryState,
} from "../feaures/store/redux/web/enquirySlice";

const Navbar = ({ data }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const enquiryStore = useSelector((state) => state.enquirySlice);

  const handleClose = () => {
    dispatch(handlePopup(false));
    setShow(false);
  };

  const handleOpenSideBar = () => {
    dispatch(handleSidebar(true));
  };

  const handleShow = () => setShow(true);

  const [favicon, setFavicon] = useState(data.favicon);

  const changeFavicon = (faviconURL) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconURL;
    document.getElementsByTagName("head")[0].appendChild(link);
  };

  const handleFaviconChange = () => {
    setFavicon(data.favicon);
    changeFavicon(data.favicon);
  };

  useEffect(() => {
    handleFaviconChange();
  }, [data.favicon]);

  const makeCall = (number) => {
    let a = document.createElement("a");
    a.href = `tel:${number}`;
    a.click();
  };

  const senMail = (email) => {
    let a = document.createElement("a");
    a.href = `mailto:${email}`;
    a.click();
  };

  const [state, setState] = useState({
    name: "",
    contactNumber: "",
    requirement: "",
    area: "",
    size: "",
    maxBudget: "",
  });

  const setValue = (val) => {
    setState((preState) => ({
      ...preState,
      requirement: val,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      path: `EnquiryForm`,
      data: state,
    };
    dispatch(saveEnquiryData(data));
  };

  useEffect(() => {
    if (enquiryStore.saveEnquiry.success) {
      toast.success(enquiryStore.saveEnquiry.message);
      setShow(false);
      dispatch(resetEnquiryState("save"));
    }
  }, [enquiryStore.saveEnquiry.success]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
      <nav className="navbar">
        <div className="left-navbar">
          <IconButton onClick={handleOpenSideBar} className="menu-icon">
            {<MenuIcon />}
          </IconButton>
          <img src={data.logo} alt="logo" width={40} />
          <span
            id="hide-mail-id"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => senMail(data.header_email)}
          >
            <EmailOutlinedIcon id="top-icon" /> &nbsp;{" "}
            <span id="email_name">{data.header_email}</span>
          </span>

          {/* <span
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            id="contact_field"
            onClick={() => makeCall(data.header_phone)}
          >
            <LocalPhoneOutlinedIcon id="top-icon" />
            &nbsp; <span id="contact_name">{data.header_phone}</span>
          </span>

          <span
            id="hide-mail-id"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => makeCall(data.header_phone2)}
          >
            &nbsp;
            <span id="email_name">, {data.header_phone2}</span>
          </span> */}
        </div>
        <h4 className="text-logo">Rich Premises</h4>
        <div className="navbar-right">
          <button className="enquiry-btn" onClick={handleShow}>
            Enquiry
          </button>
        </div>

        <Modal show={show || enquiryStore.popup.isOpen} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Enquiry</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  name="name"
                  value={state.name}
                  placeholder="Enter Name"
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mt-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  name="contactNumber"
                  value={state.contactNumber}
                  placeholder="Enter Contact Number"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Area</Form.Label>
                <Form.Control
                  name="area"
                  value={state.area}
                  placeholder="Enter Area"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Size</Form.Label>
                <Form.Control
                  name="size"
                  value={state.size}
                  placeholder="Enter Size"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Max Budget</Form.Label>
                <Form.Control
                  name="maxBudget"
                  value={state.maxBudget}
                  placeholder="Enter Max Budget"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Requirement</Form.Label>
                <ReactQuill
                  theme="snow"
                  value={state.requirement}
                  placeholder="Requirement"
                  onChange={setValue}
                  className="texteditor"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </nav>
    </>
  );
};

export default Navbar;

// name, contact, requirement, area, size, max budget
